import type { UseMutationResult } from '@tanstack/react-query';
import type { AxiosError } from 'axios';
import type { FunctionComponent } from 'react';
import type { ItemSettingsDto, PanelSettingsDto } from '../../../app/api/generated/client';
import { CashflowSettingBox } from '../../../app/components/settings-drawer';
import type { CashOccurrenceType } from '../../../app/enums';
import type { ISetting } from '../../../app/interfaces/simulation-settings';
import { LiquidityCashflowSelectAll } from './liquidity-cashflow-select-all';

interface ILiquidityCashflowSettingBoxProps {
    title: string;
    cashOccurrenceType: CashOccurrenceType;
    settings?: PanelSettingsDto;
    cashflowItems?: ItemSettingsDto[];
    updatePanelSettings: UseMutationResult<ISetting, AxiosError, ISetting>;
    updateItemSettings: UseMutationResult<ISetting, AxiosError, ISetting>;
    selectAllItems: UseMutationResult<PanelSettingsDto, AxiosError, boolean>;
    sectionKey?: string;
    expandedKey?: string;
    isUpdating?: boolean;
}

export const LiquidityCashflowSettingBox: FunctionComponent<ILiquidityCashflowSettingBoxProps> = ({
    title,
    cashOccurrenceType,
    settings,
    cashflowItems,
    updatePanelSettings,
    updateItemSettings,
    selectAllItems,
    sectionKey,
    expandedKey,
    isUpdating,
}) => (
    <CashflowSettingBox
        title={title}
        cashOccurrenceType={cashOccurrenceType}
        settings={settings}
        cashflowItems={cashflowItems}
        updatePanelSettings={updatePanelSettings}
        updateItemSettings={updateItemSettings}
        showToDateColumn={true}
        sectionKey={sectionKey}
        expandedKey={expandedKey}
        isUpdating={isUpdating}
        hideDetailHeaderWhenEmpty={true}
        isLiquiditySurplus={true}
        detailHeader={
            <LiquidityCashflowSelectAll
                cashOccurrenceType={cashOccurrenceType}
                settings={settings}
                cashflowItems={cashflowItems}
                selectAllItems={selectAllItems}
            />
        }
    />
);
